module.exports = __webpack_public_path__ + "img/Inflammation-LUCA_10X_LU.741de368.png";